import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { MediaModule } from '@spartacus/storefront';
import { CustomProductModule } from 'src/app/spartacus/custom/core/product/custom-product.module';
import { CustomAddToCartModule } from '../../../../spartacus/custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module';
import { CustomProductItemModule } from "../custom-product-item/custom-product-item.module";
import { CustomOhgarTabsItemComponent } from './custom-ohgar-tabs-item/custom-ohgar-tabs-item.component';
import { CustomOhgarTabsComponent } from './custom-ohgar-tabs.component';

@NgModule({
  declarations: [CustomOhgarTabsComponent, CustomOhgarTabsItemComponent],
  exports: [CustomOhgarTabsComponent],
  imports: [
    CommonModule,
    I18nModule,
    MediaModule,
    CustomProductModule,
    NgbNavModule,
    CustomAddToCartModule,
    NgbModule,
    CustomProductItemModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OhgarTabListComponent: {
          component: CustomOhgarTabsComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomOhgarTabsModule { }
